import { array, fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { cached } from '@glimmer/tracking';

import type { PopupData, Service } from 'webapp-types';

import eq from 'webapp/helpers/eq';
import joinClasses from 'webapp/helpers/join-classes';
import PopupInnerContextComponent from 'webapp/components/popup/inner/context';

export default class GoalsMeasurementPopupComponent extends PopupInnerContextComponent<PopupData.Goal.Measurement> {
	@service('model-manager/goals') declare mmGoalsService: Service.ModelManager.Goals;

	get model() {
		return this.popupData.model;
	}

	@cached
	get selected() {
		return this.model.measurement;
	}

	get options() {
		return this.mmGoalsService.measurementOptions;
	}

	@action
	select(value: string) {
		this.model.measurement = value;
		this.close();
	}
	<template>
		<ul class="links">
			{{#each this.options as |item|}}
				<li
					class={{joinClasses
						(array
							(if (eq this.selected item.value) "selected")
							(if item.isSeparated "separator")
						)
					}}
				>
					<a {{on "click" (fn this.select item.value)}}>
						{{item.label}}
					</a>
				</li>
			{{/each}}
		</ul>
	</template>
}
